// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  container: {
    padding: theme.spacing(2),
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  projectName: {
    fontWeight: 600,
    fontSize: '18px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
  showMoreLink: {
    fontSize: '13px',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'underline',
    marginTop: theme.spacing(1),
    display: 'inline-block',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  detailsContainer: {
    marginTop: theme.spacing(1),
    backgroundColor: '#F0F5F8',
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    borderRadius: '0 6px 6px 0',
    padding: theme.spacing(1.5),
  },
  detailRow: {
    paddingBottom: theme.spacing(1),
  },
  detailLabel: {
    fontSize: '12px',
    fontWeight: 500,
    color: theme.palette.grey[600],
    paddingBottom: theme.spacing(0.25),
  },
  detailValue: {
    fontSize: '13px',
  },
  sidebarIcon: {
    width: 24,
    height: 24,
    color: 'rgba(2, 30, 64, 1)',
    cursor: 'pointer',
  },
});

export default styles;
